import NameValue from '@/types/NameValue'
import React from 'react'
import styles from './DefaultPicker.module.scss'
import classNames from 'classnames'

type Props = {
  name: string,
  value?: string,
  placeholder?: string | null,
  options?: NameValue[],
  onChange?: (value: string, name: string) => void,
  disabled?: boolean,
  inputStyle?: 'border' | 'background',
  label?: string | null | undefined,
}

const DefaultPicker = (props: Props) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target

    if (props.onChange === undefined) return

    props.onChange(value, name)
  }

  const classes = classNames(
    styles.component,
    {
      [styles.border]: props.inputStyle === 'border',
      [styles.background]: props.inputStyle === 'background',
    }
  )

  return (
    <div className={classes}>
      {props.label && (
        <label htmlFor={props.name}>{props.label}</label>
      )}
      <select
        name={props.name}
        value={props.value}
        onChange={onChangeHandler}
        disabled={props.disabled}
      >
        {props.placeholder !== undefined && props.placeholder !== null && props.placeholder !== '' && (
          <option value="" disabled hidden>{props.placeholder}</option>
        )}
        {props.options?.map((option, index) => (
          <option
            key={index}
            value={option.value}
          >
            {option.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default DefaultPicker